var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBCabinetProfileIcon5(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8 18.4004V14.8005C11.8 14.1873 11.847 13.5873 11.9411 13.0005M32.2 18.4004V14.8005C32.2001 12.6067 31.5693 10.465 30.3914 8.66023C29.2136 6.85548 27.5446 5.4733 25.6065 4.69763C23.6685 3.92197 21.5533 3.78961 19.5424 4.31816C17.5316 4.84671 15.7204 6.01111 14.35 7.65641M20.3 40H15.2C10.3924 40 7.9869 40 6.4943 38.4178C5 36.8375 5 34.2905 5 29.2002C5 24.1099 5 21.5629 6.4943 19.9826C7.9869 18.4004 10.3924 18.4004 15.2 18.4004H28.8C33.6076 18.4004 36.0131 18.4004 37.5057 19.9826C39 21.5629 39 24.1099 39 29.2002C39 34.2905 39 36.8375 37.5057 38.4178C36.0131 40 33.6076 40 28.8 40H27.1",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBCabinetProfileIcon5);
export default __webpack_public_path__ + "static/media/b_cabinet_profile_icon5.14e7fa860ab287a6f842e253d5f39695.svg";
export { ForwardRef as ReactComponent };